(function ($, window, document, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function() {
        if ($.prototype.fancybox()) {
            $('a.image-lightbox').fancybox();
        }
    });
})(jQuery, window, document, window.PageLoadedQueue);
